const LOGOUT_MARKER_COOKIE = 'logout_in_progress';
const LOGOUT_MARKER_MAX_AGE_SECONDS = 60;

export function markLogoutInProgress(): void {
    document.cookie = `${LOGOUT_MARKER_COOKIE}=1; path=/; max-age=${LOGOUT_MARKER_MAX_AGE_SECONDS}; SameSite=Lax`;
}

export function consumeLogoutMarker(): boolean {
    const isSet = document.cookie.split('; ').some((entry) => entry.startsWith(`${LOGOUT_MARKER_COOKIE}=`));

    if (isSet) {
        document.cookie = `${LOGOUT_MARKER_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
    }

    return isSet;
}
